/** בשלב זה מוסתר; להצגה מחדש: true */
export const SHOW_SCREEN_EXAMPLES = false;
